import styled from '@emotion/styled'
import { Typography, Container, Grid } from '@mui/material'

const Heading = styled(Typography)`
    color:#fff;
    font-size:50px;
    font-family:poppinBI;
    text-align: center;
    text-transform: uppercase;
    width: 100%;
    margin-bottom: 30px;
    @media (max-width: 900px){
        margin-bottom: 15px;
        font-size:40px;
    }
`
const MainContainer = styled(Container)`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;
    padding-top:50px;
    padding-bottom:50px;
    @media(min-width: 600px){
        padding-left:0px;
        padding-right:0px;
    }
`
const TokenGrid = styled(Grid)`
    display:flex;
    justify-content: center;
    align-items: center;
`
const ImgGrid = styled(Grid)`
    display: flex;
    flex-direction: column;
    justify-content: center;
`
const Text = styled(Typography)`
    color:#fff;
    font-size:25px;
    font-family: poppinSBI;
    text-align: center;
    @media (max-width: 900px){
        font-size:18px;
    }
`
const Value = styled(Typography)`
    color:#fff;
    font-size:35px;
    font-family: poppinBI;
    text-align: center;
    text-transform: uppercase;
    @media (max-width: 900px){
        font-size:25px;
    }
`
const ImgDiv = styled.div`
    display: flex;
    justify-content: center;
`
const Symbol = styled(Typography)`
    color:#fff;
    font-size:35px;
    font-family: poppinR;
    text-align: center;
`
const ContractGrid = styled(Grid)`
    display: flex;
    justify-content: center;
    margin-top:30px;
    @media (max-width: 900px){
        margin-top: 15px;
    }
`
const ContractColumn = styled(Grid)`
    display: flex;
    flex-direction: column;
    align-items: center;
`
const ContractDiv = styled.div`
    width:100%;
    border:1px solid #fff;
    border-radius:10px;
    padding:5px 10px;
    display: flex;
    justify-content: space-between;
`
const IconImg = styled.img`
    width:150px;
    max-width: 100%;
    height:auto;
    margin-right:10px;
    margin-top:20px;
    @media (max-width: 900px){
        width:85px;
    }
`
const IconDiv = styled.div`
    display: flex;
    justify-content: space-between;
    width:100%;
`
const LeftImg = styled.img`
    position: absolute;
    width:46%;
    top:0;
    left: 0;
    @media(max-width: 600px){
        display: none;
    }
    @media (min-width: 1600px){
        width: 36%;
    }
`
const RightImg = styled.img`
    position: absolute;
    width: 63.5%;
    top:0;
    right: 0;
    @media(max-width: 600px){
        display: none;
    }
    @media (min-width: 1600px){
        width: 50%;
        right: unset;
    }
`
const Div = styled.div`
    width: 100%;
    background: linear-gradient(180deg, hsla(0, 0%, 0%, 1) 40%, hsla(48, 89%, 53%, 1) 63%, hsla(18, 100%, 62%, 1) 100%);
`
export {Heading, MainContainer,TokenGrid,ImgGrid,Text,Value,ImgDiv,Symbol,ContractGrid,ContractDiv,ContractColumn,IconImg
,IconDiv,LeftImg,Div,RightImg}
